import { useQuery } from '@tanstack/react-query';

import { type TeamShortcut } from '../../contracts';
// The cache identity and its key factory moved to `@heidi/workspace/contracts`
import { GET_TEAM_SHORTCUTS, getTeamShortcutsQueryKey } from '../../contracts/keys';
import { teamShortcutsApi } from '../api/team-shortcuts';
import { getWorkspaceDataConfig } from '../config';

export const invalidateTeamShortcuts = async (teamId: string | undefined) => {
  await getWorkspaceDataConfig().queryClient.invalidateQueries({
    queryKey: [GET_TEAM_SHORTCUTS, teamId],
  });
};

/**
 * List team shortcuts for the given team.
 * Any team member can read the list (backend enforces PERMISSION_TEAM_VIEW).
 */
export function useQueryTeamShortcuts(teamId: string | undefined, enabled = true) {
  return useQuery<TeamShortcut[]>({
    queryKey: getTeamShortcutsQueryKey(teamId),
    queryFn: () => {
      if (!teamId) throw new Error('teamId is required');
      return teamShortcutsApi.list(teamId);
    },
    enabled: enabled && !!teamId,
    staleTime: 1000 * 60,
  });
}
